import React from 'react'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import styled from 'styled-components'
import { SelectOption } from '../SelectDropdown/SelectDropdown'
import { EmailFilterTag, selectEmailFilterTags, setEmailFilterTags } from '../../store/emailHub/emailFilters'

const EmailTagFilter = styled.div<{ selected: boolean }>`
  border: 1px dashed var(--zocks-gray-500);
  background: ${(props) => (props.selected ? 'var(--zocks-gray-200)' : '#fff')};
  border-color: ${(props) => (props.selected ? 'var(--zocks-gray-200)' : 'var(--zocks-gray-500)')};

  &:hover {
    border-style: solid;
  }
`

export interface EmailTagsFilterProps {
  disabled?: boolean
}

export const EmailTagsFilter: React.FC<EmailTagsFilterProps> = ({ disabled = false }) => {
  const dispatch = useAppDispatch()
  const selectedTags = useAppSelector(selectEmailFilterTags)
  const selectOptionFilterTagMapping: { [key: string]: EmailFilterTag } = {
    new: { attr: 'new', val: true },
    processed: { attr: 'processed', val: true },
    replyGenerated: { attr: 'replyGenerated', val: true },
  }
  const selectableTags: SelectOption[] = [
    { id: 'new', label: 'New' },
    { id: 'replyGenerated', label: 'Reply generated' },
    { id: 'processed', label: 'Processed' },
  ]

  const handleTagClicked = (tag: SelectOption, selected: boolean) => {
    if (disabled) {
      return
    }
    if (selected) {
      dispatch(setEmailFilterTags([...selectedTags, selectOptionFilterTagMapping[tag.id]]))
    } else {
      const optionFilterTag = selectOptionFilterTagMapping[tag.id]
      dispatch(setEmailFilterTags(selectedTags.filter((t) => optionFilterTag && t.attr !== optionFilterTag.attr)))
    }
  }

  return (
    <div className='d-flex flex-column gap-2'>
      <div className='lead-extra-small'>Filter by tags {selectedTags.length ? <>({selectedTags.length})</> : null}</div>
      <div className='d-flex gap-1 flex-wrap'>
        {selectableTags.map((tag) => {
          const isSelected = !!selectedTags.find((filterTag) => {
            const optionFilterTag = selectOptionFilterTagMapping[tag.id]
            return optionFilterTag && filterTag.attr === optionFilterTag.attr && filterTag.val === optionFilterTag.val
          })
          return (
            <EmailTagFilter
              className='d-flex p-2 align-items-center gap-2 zocks-border-0.25 cursor-pointer'
              key={tag.id}
              selected={isSelected}
              onClick={() => handleTagClicked(tag, !isSelected)}
            >
              {isSelected ? <i className='bi bi-check2-circle' /> : <i className='bi bi-plus-circle' />} {tag.label}
            </EmailTagFilter>
          )
        })}
      </div>
    </div>
  )
}
